<template>
  <div>
    <header class="header">
      <div class="header__logo">
        <div class="dropdown">
          <div class="header__logo__items">
            <div class="header__logo__img" data-toggle="dropdown"
              v-if="(user && user.profile_image) || user.square_company_logo">
              <img :src="user.square_company_logo" alt="Logo" />
            </div>
            <div data-toggle="dropdown" class="cursor-pointer" v-else>
              <img src="@/assets/images/header_default_logo.png" alt="Logo" />
            </div>
            <div class="dropdown-menu header__dropdown__menu">
              <router-link to="/dashboard">Dashboard</router-link>
              <router-link to="/permit" v-if="hide_permit == false">Permits</router-link>
              <router-link to="/users" v-if="show_operators == true">Operators</router-link>
              <router-link to="/validation" v-if="hide_validation == false">Validations</router-link>
              <router-link to="/report" v-if="hide_report == false">Reports</router-link>
              <router-link to="/audit" v-if="admin_access == true">Audits</router-link>
              <!-- <a class="opacity--40" v-if="admin_access == true" @click="openModal('refund-amount')" href="javascript:void(0);">Refunds
                <span class="txt--red ml-2"><i class="fa fa-circle fa-xs" aria-hidden="true"></i></span>
              </a> -->
              <a href="javascript:void(0);" @click="openIntercom">Support</a>
              <a class="opacity--50" @click="openModal('account-settings')" href="javascript:void(0);">Account
                Settings</a>
              <a class="opacity--50" exact href="javascript:void(0);" @click="logout">Sign Out</a>
            </div>
            <div class="header__logo__txt ml-3">
              <p class="txt--s txt--semi-bold mb-2" v-if="user.company != ''">
                {{ user.company }}
              </p>
              <p class="txt--s txt--semi-bold mb-2" v-else>
                {{ user.first_name }} {{ user.last_name }}
              </p>
              <p class="txt--ss mb-0" v-if="user.company != ''">
                {{ user.first_name }} {{ user.last_name }}
              </p>
            </div>
            <div class="header__logo__txt ml-3" style="position: relative;">
              <button type="button" class="btn" data-toggle="modal" data-target="#exampleModalCenter">
                <input type="text" placeholder="Type Here ....." class="input__field"
                  v-show="$route.name !== 'Property'" v-if="admin_access || role == 'commercial' || role == 'operator'"
                  @click="openModal('user-active-permit')" />
              </button>
              <!-- <p class="txt--s txt--semi-bold mb-4">

                <input
                  type="text"
                  placeholder="Type Here ....."
                  class="input__field"
                  v-model="property_search"
                  v-show="$route.name!=='Property'"
                />
              </p> -->

              <!-- <div class="filter__items" v-if="property_search != ''" style="width: 613px; height: 452px;">
                <div class>
                  <div class="mt-3">
                    <div class="top__filter">
                      <ul class="top__filter__ul">
                        <li class="cursor-default">Property List</li>
                      </ul>
                      <ul class="top__filter__ul" v-if="property_search != ''">
                        <li id="clear_filter_property" @click="clearSearch">
                          Clear
                        </li>
                        <li>None</li>
                      </ul>
                    </div>
                    <div
                      class="propertyFilters"
                      v-if="property_list.length > 0"
                    >
                      <p
                        class="
                          txt--primary txt--ss
                          my-3
                          txt--semi-bold
                          cursor-pointer
                        "
                        v-for="(p, index) in property_list"
                        :key="index"
                        @click="redirectPropertyDetails(p.id)"
                      >
                        <span
                          class="cursor-pointer property_item"
                        >
                          {{
                            p.property_name != ""
                              ? p.property_name
                              : p.address.split(",")[0]
                          }}
                          (Active Permit) </span
                        ><br />
                        <span class="cursor-pointer property_item">
                          {{ p.address }}
                        </span>
                      </p>
                    </div>
                    <div
                      class="propertyFilters d-flex justify-content-center"
                      v-else
                    >
                      <p class="txt--primary txt--ss my-3 txt--semi-bold">
                        No Property Found
                      </p>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <ul
        class="top__filter__ul top__filter__ul--header"
        v-if="
          ($route.name == 'Dashboard' || $route.name == 'Property') &&
          !hide_report
        "
      > -->
      <ul class="top__filter__ul top__filter__ul--header" v-if="
        ($route.name == 'Property') &&
        !hide_report
      ">
        <li :class="[active == 1 ? 'active' : '']" @click="switcher(1)">
          Today
        </li>
        <li :class="[active == 2 ? 'active' : '']" @click="switcher(2)">
          Week
        </li>
        <li :class="[active == 3 ? 'active' : '']" @click="switcher(3)">
          Month
        </li>
        <li :class="[active == 4 ? 'active' : '']" @click="switcher(4)">
          Year
        </li>
      </ul>
      <div class="header__txt">
        <p class="txt--ss opacity--50">{{ clock_time }}</p>
      </div>
      <accountSettings v-if="Object.keys(user).length > 0" :user="user" @Profile_updated="getData" />
    </header>
    <!-- <PopUpChat
      v-if="Object.keys(user).length > 0"
      :open="openSupport"
      :user="user"
      @opened="handleOpened"
    ></PopUpChat> -->
    <UserActivePermit @user_update="getProperties" />
    <!-- <RefundAmount /> -->
  </div>

</template>

<script>
import accountSettings from "@/components/modals/accountSettings";
// import PopUpChat from "@/components/PopUpChat";
import UserActivePermit from "@/components/modals/UserActivePermit";
// import RefundAmount from "@/components/modals/refundAmount";
import VueCookies from "vue-cookies";

export default {
  name: "TopHeader",
  components: {
    accountSettings,
    UserActivePermit,
    // RefundAmount
    // PopUpChat,
  },
  data() {
    return {
      user: {},
      week: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      clock_time: "",
      active: 1,
      show_operators: false,
      openSupport: false,
      hide_permit: true,
      hide_validation: true,
      hide_report: true,
      hide_audit: true,
      admin_access: false,
      property_search: "",
      page: "",
      load_more: false,
      property_list: [],
      pagination: [],
      search_infiniteId: +new Date(),
      role: '',
      admin_name: '',
      admin_id: '',
      admin_hash: '',
      admin_profile_image: '',
      admin_email: ''
    };
  },
  watch: {
    property_search: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.page = 1;
        this.load_more = true;
        this.getProperties();
      }
    },
  },
  created() {
    this.role = localStorage.getItem('role');
    //  console.log(role);
    var active_val = VueCookies.get("active_val")
      ? VueCookies.get("active_val")
      : "1";
    this.active = active_val;
    if (
      localStorage.getItem("admin_access") &&
      localStorage.getItem("admin_access") == "true"
    ) {
      this.admin_access = true;
    }
    this.clock();
    this.getData();
    this.reportStore();
    this.getProperties();
  },
  methods: {
    openModal(modalName) {
      this.$modal.show(modalName);
    },
    logout() {
      this.axios
        .post(window.hostname + "/api/auth/logout")
        .then((res) => {
          localStorage.clear();
          this.$intercom.shutdown();
          this.$router.push({ name: "Login" });
        })
        .catch((err) => {
          localStorage.clear();
          this.$intercom.shutdown();
          this.$router.push({ name: "Login" });
        });
    },
    containsKey(obj, key) {
      return Object.keys(obj).includes(key);
    },
    getData() {
      this.user = {};
      this.axios
        .post(window.hostname + "api/auth/users", {
          mode: "details",
          device_type: "1",
          commercial: 1,
        })
        .then((res) => {
          this.user = res.data.data;
          localStorage.setItem("commercial_user_id", this.user.company_id || this.user.id);

          if (this.user.role == "operator") {
            this.show_operators = false;
            if (
              this.containsKey(this.user.access, "report_access") &&
              this.user.access.report_access == true
            ) {
              this.hide_report = false;
            }

            if (
              this.containsKey(this.user.access, "permit_access") &&
              this.user.access.permit_access == true
            ) {
              this.hide_permit = false;
            }

            if (
              this.containsKey(this.user.access, "validation_access") &&
              this.user.access.validation_access == true
            ) {
              this.hide_validation = false;
            }

            if (
              this.containsKey(this.user.access, "audit_access") &&
              this.user.access.audit_access == true
            ) {
              this.hide_audit = false;
            }

            localStorage.setItem(
              "commercial_access_list",
              JSON.stringify(this.user.access)
            );
            localStorage.setItem("role", this.user.role);
            window.EventBus.$emit("access_update");
          } else if (this.admin_access == true) {
            this.show_operators = true;
            this.hide_report = false;
            this.hide_permit = false;
            this.hide_audit = false;
            this.hide_validation = false;
          } else if (this.user.role == "commercial") {
            this.show_operators = true;
            this.hide_report = false;
            this.hide_permit = false;
            this.hide_audit = true;
            this.hide_validation = false;
          }
          //================== Intercom ===============//
          if (
            localStorage.getItem("admin_access") &&
            localStorage.getItem("admin_access") == "true"
          ) {
            this.admin_id = localStorage.getItem("admin_id");
            this.admin_name = localStorage.getItem("admin_name");
            this.admin_hash = localStorage.getItem("admin_hash");
            this.admin_email = localStorage.getItem("admin_email");
            this.admin_profile_image = localStorage.getItem("admin_profile_image");
            this.$intercom.boot({
              user_id: this.admin_id,
              name: this.admin_name,
              email: this.admin_email,
              avatar: {
                type: "avatar",
                image_url:
                  this.admin_profile_image != ""
                    ? this.admin_profile_image
                    : '',
              },
              user_hash: this.admin_hash,
            });
          }
          else {
            this.$intercom.boot({
              user_id: this.user.id,
              name: this.user.first_name + " " + this.user.last_name,
              email: this.user.email,
              avatar: {
                type: "avatar",
                image_url:
                  this.user.company_logo != ""
                    ? this.user.company_logo
                    : this.user.profile_image,
              },
              user_hash: this.user.hash,
            });
          }

          this.$intercom.update();
          //================= Intercom Ends ================//
        })
        .catch((error) => {
          console.log(error);
          // localStorage.removeItem("commercial_token_new");
          // this.$router.replace({ name: "Login" });
        });
      // console.log(this.$intercom.unreadCount);
    },
    clock() {
      let date = new Date();

      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      hours = hours >= 10 ? hours : "0" + hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      let time = hours + ":" + minutes + " " + ampm;
      let full_date =
        this.week[date.getDay()] +
        ", " +
        " " +
        this.months[date.getMonth()] +
        " " +
        date.getDate() +
        "," +
        " " +
        date.getFullYear();
      this.clock_time = full_date + " " + time;
      const self = this;
      setTimeout(() => {
        self.clock();
      }, 1000);
    },
    openIntercom() {
      this.$intercom.show();
    },
    switcher(active) {
      VueCookies.remove();
      VueCookies.set("active_val", active, "24h");
      this.active = active;
      window.EventBus.$emit("report_switcher", this.active);
    },
    reportStore() {
      this.axios
        .post(window.hostname + "/api/auth/update-reports")
        .then((res) => {
          console.log("Reports Generated!");
        })
        .catch((err) => {
          console.log("Report Generation Failed!");
        });
    },
    handleOpened(e) {
      this.openSupport = e;
    },
    getProperties() {
      let property_access = [];
      let property_access_list = '';
      let role = localStorage.getItem('role');
      if (role == 'operator') {
        property_access = localStorage.getItem('commercial_access_list');
        property_access = JSON.parse(property_access)
        property_access_list = property_access.property_access_list;
      }
      else {
        property_access_list = [];
      }
      this.axios
        .post(window.hostname + "api/auth/permit/search-properties", {
          search: this.property_search,
          page: this.page,
          admin_access: this.admin_access,
          access_property_ids: property_access_list,
          commercial: 1

        })
        .then((res) => {
          console.log(res);
          if (res.status) {
            // console.log(res.data.data.property_list);
            this.property_list = res.data.data.user_details;
            this.pagination = res.data.data.pagiantion;
            this.load_more = res.data.data.pagination.load_more == 1 ? true : false;
            this.page = res.data.data.pagination.load_more == 1 ? res.data.data.pagination.page : 1;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getPaginateUsers($state) {
      let property_access = [];
      let property_access_list = '';
      let role = localStorage.getItem('role');
      if (role == 'operator') {
        property_access = localStorage.getItem('commercial_access_list');
        property_access = JSON.parse(property_access)
        property_access_list = property_access.property_access_list;
      }
      else {
        property_access_list = '';
      }
      await this.axios
        .post(window.hostname + "api/auth/permit/search-properties", {
          search: this.property_search,
          admin_access: this.admin_access,
          page: this.page,
          access_property_ids: property_access_list,
        })
        .then(res => {
          // console.log(res);
          // this.monthly_loader = false ;
          if (res.status) {
            if (Object.keys(res.data.data).length !== 0) {
              let data = res.data.data.user_details;
              // console.log("data",data);
              data.map(val => {
                this.property_list.push(val);
              });
              // console.log( res.data.data.pagination.load_more);
              this.load_more = res.data.data.pagination.load_more == 1 ? true : false;
              this.page = res.data.data.pagination.load_more == 1 ? res.data.data.pagination.page : 1;
              console.log(res.data.data.pagination.load_more);
              $state.loaded();
              if (!this.load_more) {
                $state.complete();
              }
            } else {
              this.property_list = [];
              this.load_more = false;
              // this.search_infiniteId += 1;
              this.page = 1;
              $state.complete();
            }
          }
        })
        .catch(err => {
          if (this.axios.isCancel(err)) {
            // this.monthly_loader = true ;
            console.log('Request canceled', err.message);
          }
          else {
            // this.monthly_loader = false ;
            $state.error();
            console.log(err);
          }
        });
    },
    clearSearch() {
      this.property_search = "";
    },
    redirectPropertyDetails(property_id) {
      // console.log(property_id);
      this.$router.push({
        name: "Property",
        query: {
          p: property_id,
          redirect: 'property_search',
          data: this.property_search
        },
      }).catch(() => { });
      this.clearSearch();
      // this.$forceUpdate()
    }
  },
  mounted() {
    var ActObj = this.active;
    var ActiveINT = parseInt(ActObj);
    window.EventBus.$emit("report_switcher", ActiveINT);
  },
};
</script>

<style>
</style>
